<template>
  <div class="point">
    <div class="imageWarpper" >
      <img
        :src="point.thumbnail||'https://chingshen-public.oss-cn-hangzhou.aliyuncs.com/statics/yuetu/default_300-200.jpg'"
        @click="handleClick(point)"
        style="width: 150px; height: 100px"
        onerror="javascript:this.src='/default_300-200.jpg';"
      />
    </div>
    <div
      v-if="point.status !== 'created'"
      class="status"
      :class="{
        'success': point.status === 'approved' , 
        'danger': point.status === 'rejected',
        'warning': point.status === 'appealed'
      } "
      size="mini"
      effect="dark"
      >{{ filterStatus(point.status).label }}</div
    >
    <div
      v-if="rule.scoreable"
      class="point-score"
      :class="point.score > 0 ? 'success' : 'danger'"
      size="mini"
      effect="dark"
      >{{ point.score }} 分</div
    >
    <div class="info">
      <div class="poi"><i class="el-icon-location"></i> {{ point.poi ? point.poi : '无' }}</div>
      <div v-if="point.surveyor">
        <i class="el-icon-user"></i> {{ point.surveyor.name }}
      </div>
    </div>
    <PointDetailDialog  v-on='$listeners' ref="pointDetailDialog" :statuses="statusList" />
  </div>
</template>
<script>
import PointDetailDialog from "./point-detail-dialog.vue";

export default {
  data() {
    return {
      statusList: [
        {
          value: "created",
          label: "已创建"
        },
        {
          value: "appealed",
          label: "已申诉"
        },
        {
          value: "approved",
          label: "申诉成功"
        },
        {
          value: "rejected",
          label: "申诉被拒"
        }
      ]
    };
  },
  methods: {
    filterStatus(type) {
        return this.statusList.filter((item) => item.value == type)[0];
    },
    handleClick(data) {
      this.$refs.pointDetailDialog.show(data);
    }
  },
  components: {
    PointDetailDialog
  },
  props: {
    point: {
      type: Object,
      default: () => {
        return {};
      }
    },
    rule: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>
<style lang="less" scoped>
.point {
  position: relative;
  background-color: white;
  border: 1px solid #f4f4f4;
  margin: 2px;
  width: 150px; 
  // height: 100px;

  .info {
    padding: 5px;
    font-size: 12px;
    .poi {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    
    }
  }

  .point-score {
    position: absolute;
    top: 5px;
    left: 5px;
    height: 23px;
    width: 60px;

    text-align: center;
    color: white;
    font-size: 12px;
    line-height: 23px;
    &.danger {
      background-color: #f56c6c;
    }
    &.success {
      background-color: #67c23a;
    }
  }

  .status {
    position: absolute;
    top: 28px;
    left: 5px;
    width: 60px;
    height: 23px;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.8);
    text-align: center;
    font-size: 12px;
    line-height: 23px;

    &.danger {
      color: #f56c6c;
      border: 1px solid #f56c6c;
    }
    &.success {
      color: #67c23a;
      border: 1px solid #67c23a;
    }
    &.warning {
      color: #e6a23c;
      border: 1px solid #e6a23c;
    }
  }
}

// .imageWarpper {
//   position: relative;
//   .status {
//     position: absolute;
//     left: 5px;
//     top: 5px;
//     color: #fff;
//     background: #ccc;
//     border-radius: 15px;
//     padding:0 5px;
//   }
// }
</style>
